/* Epicerie du Chateau - interactions (porte depuis la maquette, null-safe multi-pages) */
(function () {
  'use strict';

  // Mobile menu
  var burger = document.getElementById('burgerBtn');
  var mobileMenu = document.getElementById('mobileMenu');
  var menuOverlay = document.getElementById('menuOverlay');
  var menuClose = document.getElementById('menuClose');

  function openMenu() {
    mobileMenu.classList.add('open');
    burger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu.classList.remove('open');
    burger.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
    });
  }
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  document.querySelectorAll('.mobile-menu__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href && href.indexOf('#') !== 0) {
        e.preventDefault();
        closeMenu();
        setTimeout(function () { window.location.href = href; }, 50);
      } else {
        closeMenu();
      }
    });
  });

  // Nav scroll state
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // Hero image zoom on load
  var heroWrap = document.getElementById('heroImageWrap');
  if (heroWrap) {
    window.addEventListener('load', function () { heroWrap.classList.add('loaded'); });
  }

  // Scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  // Animated counters
  var countEls = document.querySelectorAll('.count');
  if (countEls.length && 'IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.target, 10);
        var duration = 1800;
        var start = performance.now();
        var animate = function (now) {
          var progress = Math.min((now - start) / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(ease * target);
          if (progress < 1) requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
        counterObserver.unobserve(el);
      });
    }, { threshold: 0.5 });
    countEls.forEach(function (el) { counterObserver.observe(el); });
  }

  // Parallax hero on scroll
  var heroImg = document.getElementById('heroImg');
  if (heroImg) {
    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY;
      if (scrolled < window.innerHeight) {
        // scale 1.15 = marge (overscan) pour que la translation n'expose jamais de vide
        heroImg.style.transform = 'scale(1.15) translateY(' + (scrolled * 0.06) + 'px)';
      }
    }, { passive: true });
  }

  // Product card hover - lift sibling cards
  var pcards = document.querySelectorAll('.product-card');
  pcards.forEach(function (card) {
    card.addEventListener('mouseenter', function () {
      pcards.forEach(function (c) { if (c !== card) c.style.opacity = '0.75'; });
    });
    card.addEventListener('mouseleave', function () {
      pcards.forEach(function (c) { c.style.opacity = ''; });
    });
  });

  // Gallery items stagger on reveal
  document.querySelectorAll('.gallery__item').forEach(function (item, i) {
    item.style.transitionDelay = (i * 0.08) + 's';
  });

  // Cart badge - branche sur le panier Shopify (rendu serveur + maj apres ajout AJAX)
  function refreshCartBadge(count) {
    var badge = document.getElementById('navCartCount');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count > 9 ? '9+' : count;
      badge.classList.add('visible');
    } else {
      badge.classList.remove('visible');
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { refreshCartBadge(cart.item_count); })
      .catch(function () {});
  });

  // Toast leger
  function showToast(msg) {
    var t = document.getElementById('omp-toast');
    if (!t) { t = document.createElement('div'); t.id = 'omp-toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._tm);
    t._tm = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  // Quick-add depuis les cartes catalogue (sans quitter la page, panier natif Shopify)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (btn) { btn.classList.add('added'); setTimeout(function () { btn.classList.remove('added'); }, 1000); }
        showToast('Ajouté au panier');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) refreshCartBadge(cart.item_count); })
      .catch(function () { showToast('Indisponible pour le moment'); });
  });
})();
